import { Box, Typography, Radio, Table, TableBody, TableCell, TableHead, TableRow, Select, MenuItem } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

const MatrixQuestion = ({ question, questionNumber, answerOptions, onAnswerChange, answer }) => {
  const isMobile = useMediaQuery('(max-width:900px)'); // Detect if the screen is mobile

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {questionNumber}. {question.text}
      </Typography>
      {isMobile ? (
        // Mobile view with dropdowns
        <Table size="small">
          <TableBody>
            {question.items.map((item, rowIdx) => (
              <TableRow key={item}>
                <TableCell sx={{ width: '50%' }}>{item}</TableCell>
                <TableCell sx={{ width: '50%' }}>
                  <Select
                    value={answer?.[rowIdx] ?? ''} // Ensure value is not undefined
                    onChange={
                      onAnswerChange === null ? null :
                      (e) => onAnswerChange(parseInt(e.target.value, 10), rowIdx)
                    }
                    fullWidth
                    displayEmpty
                    sx={{
                      fontSize: '0.875rem', // Smaller font size
                      '& .MuiSelect-select': {
                        padding: '8px', // Adjust padding for better appearance
                      },
                    }}
                    readOnly={onAnswerChange === null}
                  >
                    {/* <MenuItem value="" disabled></MenuItem> */}
                    {answerOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        // Desktop view with radio buttons
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell />
              {answerOptions.map((option) => (
                <TableCell key={option.value} align="center">{option.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {question.items.map((item, rowIdx) => (
              <TableRow key={item}>
                <TableCell>{item}</TableCell>
                {answerOptions.map((option) => (
                  <TableCell key={option.value} align="center">
                    <Radio
                      checked={answer?.[rowIdx] === option.value}
                      onChange={
                        onAnswerChange === null ? null :
                        () => onAnswerChange(option.value, rowIdx)
                      }
                      value={option.value}
                      name={`${question.id}-${rowIdx}`}
                      disableRipple={onAnswerChange === null}
                      disableFocusRipple={onAnswerChange === null}
                      disableTouchRipple={onAnswerChange === null}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
};

export default MatrixQuestion;